import { formatISO } from 'date-fns';

export const dateToISODate = (date: Date) => {
  return formatISO(new Date(date), {
    representation: 'date',
  });
};
